"use client";

import { useEffect, useState, useRef } from "react";
import { useParams } from "next/navigation";
import HeaderInner from "@/components/HeaderInner";
import BookTableModal from "@/components/BookTableModal";
import Image from "next/image";
import * as ReactDOM from "react-dom";
import { getUserInfo } from "../../../../utilities/userInfo";
import FilterBar from "@/app/cin_booking_engine/Filterbar";
import { BookingEngineProvider } from "@/app/cin_context/BookingEngineContext";
import TigerLoader from "@/components/TigerLoader";

export default function DiningPage() {
  const [diningData, setDiningData] = useState([]);
  const [propertyData, setPropertyData] = useState([]);
  const [selectedTitle, setSelectedTitle] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [propertyId, setPropertyId] = useState(null);
  const { propertySlug } = useParams();
  const [expandedItems, setExpandedItems] = useState({});
  const [isOpen, setOpen] = useState(false);
  const [showFilterBar, setShowFilterBar] = useState(false);
  const filterBarRef = useRef(null);
  const [staahPropertyId, setStaahPropertyId] = useState(null);
  const [cityDetails, setCityDetails] = useState(null);
  const [isExpandedMain, setIsExpandedMain] = useState(false);
  const [brandId, setBrandId] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  const [isPageLoading, setIsPageLoading] = useState(true);
  const [brandData, setBrandData] = useState([]);
  const [dineBannerData, setDineBannerData] = useState([]);

  const mainText = `Enjoy a delightful dining experience featuring a variety of flavors crafted by expert chefs. Relax in a warm and elegant ambiance perfect for every occasion. Savor every bite as you indulge in a memorable culinary journey.`;

  const brandColors = {
    1: "#bf1e2d",
    4: "#bf1e2d",
    2: "#263997",
    3: "#f04e02",
    5: "#febb19",
    6: "#f9e12e",
  };

  const backgroundColor = brandColors[brandId] || "#f26624";

  useEffect(() => {
    typeof window !== "undefined" && window.scrollTo(0, 0);
    const storedBrandId = localStorage.getItem("brandId");
    setBrandId(storedBrandId);
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize(); // Run at load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fetch brand data
  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_ORANGE_TIGER_BASE_URL}/Api/property/GetBrandList`
        );
        const json = await res.json();
        setBrandData(json.data || []);
      } catch (e) {
        console.error("Error fetching brands:", e);
      }
    })();
  }, []);

  useEffect(() => {
    if (!propertySlug) return;

    const fetchPropertyIdFromSlug = async (slug) => {
      try {
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_ORANGE_TIGER_BASE_URL}/Api/property/GetPropertyList`
        );
        const json = await res?.json();
        if (json.errorMessage !== "success") {
          console.error("Property list fetch error:", json);
          return null;
        }
        const found = json.data.find((p) => p.propertySlug === propertySlug);
        setPropertyData(found);
        setCityDetails({
          label: found?.cityName,
          value: found?.cityId,
          property_Id: found?.staahPropertyId,
        });
        setStaahPropertyId(found?.staahPropertyId);
        return found?.propertyId || null;
      } catch (error) {
        console.error("Error fetching property list:", error);
        return null;
      }
    };

    const loadPropertyId = async () => {
      // setLoading(true);
      const id = await fetchPropertyIdFromSlug(propertySlug);
      setPropertyId(id);
      // setLoading(false);
    };

    loadPropertyId();
  }, [propertySlug]);

  useEffect(() => {
    const fetchDiningDetails = async () => {
      try {
        const res = await fetch(
          `${process.env.NEXT_PUBLIC_ORANGE_TIGER_BASE_URL}/Api/property/GetPropertyDineBanner?propertyId=${propertyId}`
        );
        const json = await res.json();
        if (
          json?.errorCode === "0" &&
          Array.isArray(json.data) &&
          json.data.length > 0
        ) {
          setDineBannerData(json.data?.[0]);
          setDiningData(json.data?.[0]?.dineDetails || []);
        } else {
          console.warn("No data found in API");
          setDiningData([]);
        }
      } catch (err) {
        console.error("Error fetching dining details:", err);
        setDiningData([]);
      } finally {
        setIsPageLoading(false);
      }
    };

    fetchDiningDetails();
  }, [propertyId]);

  const toggleExpand = (idx) => {
    setExpandedItems((prev) => ({
      ...prev,
      [idx]: !prev[idx],
    }));
  };

  const handlePropertyBookNow = async () => {
    setOpen(!isOpen);
    setShowFilterBar(!showFilterBar);
    if (filterBarRef.current) {
      filterBarRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      const firstInput = filterBarRef.current.querySelector(
        "input, select, button"
      );
      if (firstInput) firstInput.focus();
    }
  };

  async function postBookingWidged(
    rooms,
    mapping,
    isClose,
    ctaName,
    selectedPropertyId
  ) {
    const resp = await getUserInfo();
    const sessionId = sessionStorage?.getItem("sessionId");
    const payload = {
      ctaName: ctaName,
      urls: window.location.href,
      cityId: "0",
      propertyId: selectedPropertyId?.toString() || "0",
      checkIn: "",
      checkOut: "",
      adults: "0",
      children: "0",
      rooms: "0",
      promoCode: "",
      ip: resp?.ip,
      sessionId: sessionId,
      deviceName: resp?.deviceInfo?.deviceName,
      deviceType:
        resp?.deviceInfo?.deviceOS == "Unknown"
          ? resp?.deviceInfo?.platform
          : resp?.deviceInfo?.deviceOS,
      roomsName: rooms?.RoomName,
      packageName: mapping?.MappingName,
      isCartOpen: mapping?.MappingName ? "Y" : "N",
      isCartEdit: "N",
      isCartClick: "N",
      isClose: isClose ? "Y" : "N",
    };
       const response = await fetch(
         `${process.env.NEXT_PUBLIC_CMS_BASE_URL}/Api/tracker/BookingWidged`,
         {
           method: "POST",
           headers: {
             "Content-Type": "application/json",
           },
           body: JSON.stringify( payload ),
         }
       );
       const res = await response?.json();
  }

  if (isPageLoading) {
    return <TigerLoader />;
  }

  return (
    <main className="bg-white">
      <HeaderInner
        brandData={brandData}
        brandId={brandId}
        propertyData={propertyData}
        backgroundColor={backgroundColor}
        propertyId={propertyData?.propertyId}
        onClick={handlePropertyBookNow}
      />
      <section ref={filterBarRef} className="position-relative">
        <section
          className="position-fixed start-0 w-100 bg-white shadow"
          ref={filterBarRef}
        >
          {showFilterBar && typeof window !== "undefined" &&
            ReactDOM.createPortal(
              <section className="filter-bar-hotels-cin">
                <BookingEngineProvider>
                  <FilterBar
                    selectedProperty={parseInt(staahPropertyId)}
                    cityDetails={cityDetails}
                    openBookingBar={showFilterBar}
                    onClose={(isReload) => {
                      setOpen(false);
                      setShowFilterBar(false);
                      if (isReload) {
                        window.location.reload();
                      }
                    }}
                    isCloseButtonShow="true"
                    backgroundColor={backgroundColor}
                  />
                </BookingEngineProvider>
              </section>,
              document.body
            )}
        </section>
      </section>
      {/* Heading */}
      <div style={{ paddingTop: "90px" }}></div>
      <div className="text-center mb-16">
        <h1
          className="uppercase mt-3 fw-semibold custom-hotel-header md:text-[23px] mb-3"
          style={{ color: backgroundColor }}
        >
          {dineBannerData?.dineBannerTitle}
        </h1>
        <div
          className="w-10 h-1 bg-orange-500 mx-auto mt-2 mb-4"
          style={{ background: backgroundColor }}
        ></div>
        <p className="mt-2 text-gray-600 max-w-2xl mx-auto custom-hotel-description px-3">
          <span
            dangerouslySetInnerHTML={{
              __html:
                isExpandedMain ||
                (dineBannerData?.dineBannerDesc?.replace(/<[^>]*>/g, "")
                  .length || 0) <= (isMobile ? 120 : 150)
                  ? dineBannerData?.dineBannerDesc || ""
                  : `${dineBannerData?.dineBannerDesc
                      ?.replace(/<[^>]*>/g, "")
                      .slice(0, isMobile ? 120 : 150)}...`,
            }}
          />

          {dineBannerData?.dineBannerDesc?.replace(/<[^>]*>/g, "").length >
            (isMobile ? 120 : 150) && (
            <button
              onClick={() => setIsExpandedMain(!isExpandedMain)}
              className="text-orange-600 ml-2 underline fw-semibold"
              style={{ color: backgroundColor }}
            >
              {isExpandedMain ? "Read Less" : "Read More"}
            </button>
          )}
        </p>
      </div>

      {/* Dining Sections */}
      <div className="space-y-24 mb-5 container">
        {diningData?.map((item, idx) => (
          <div
            key={idx}
            className={`relative flex flex-col md:flex-row ${
              idx % 2 !== 0 ? "md:flex-row-reverse" : ""
            } md:items-center md:gap-12`}
          >
            {/* Image */}
            <div className="md:w-1/2">
              <Image
                src={item?.dineImages?.[0]?.dineImage || "/no_image.jpg"}
                alt={item?.dineName || "Dine Image"}
                height={500}
                width={500}
                className="w-full h-60 md:h-90 object-cover rounded-0 shadow-lg"
              />
            </div>

            {/* Overlapping Card with transparent background layer */}
            <div className="md:w-1/2 relative z-10 md:-ml-20 md:-mr-20">
              {/* Transparent Layer */}
              <div className="absolute -left-4 w-full h-full bg-white trans-layer -z-10"></div>

              {/* White Card */}
              <div className="bg-white shadow-lg p-8 relative z-10 rounded-0">
                <h3
                  className="custom-hotel-dineHeader font-bold mb-3"
                  style={{ color: backgroundColor }}
                >
                  {item?.dineName}
                </h3>
                <p className="text-[14px] text-gray-600 mb-4">
                  {expandedItems[idx] ||
                  item.dineDesc.length <= (isMobile ? 120 : 250)
                    ? item.dineDesc
                    : item.dineDesc.slice(0, isMobile ? 120 : 250) + "..."}

                  {item.dineDesc.length > (isMobile ? 120 : 150) && (
                    <button
                      className="text-orange-600 ml-2 underline fw-semibold"
                      onClick={() => toggleExpand(idx)}
                      aria-expanded={!!expandedItems[idx]}
                      aria-controls={`dine-desc-${idx}`}
                      style={{ color: backgroundColor, fontSize: "12px" }}
                    >
                      {expandedItems[idx] ? "Read Less" : "Read More"}
                    </button>
                  )}
                </p>
                <p className="text-[12px] font-semibold mb-2">
                  Timings:{" "}
                  <span className="font-normal">{item?.openingHours || "6:30 AM"} - {item?.closingHours || "11:00 PM"}</span>
                </p>
                <p className="text-[12px] mb-6">
                  Kindly call us at{" "}
                  <span className="font-semibold">{item?.mobileNoForCall || "+91 11 4766 1200"}</span> for
                  more information.
                </p>
                <button
                  className="bg-orange-600 text-white custom-button px-3 py-2 rounded-0 shadow hover:bg-orange-700"
                  onClick={() => {
                    setSelectedTitle(item?.dineName); // Set selectedTitle to the current slide's title
                    setShowModal(true); // Show the modal
                  }}
                  style={{ background: backgroundColor }}
                >
                  Reserve a Table
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
      <BookTableModal
        backgroundColor={backgroundColor}
        show={showModal}
        onClose={() => setShowModal(false)}
        hotelName={selectedTitle} // Pass selectedTitle to the modal as hotelName
        propertyData={propertyData}
      />
    </main>
  );
}
